/* Automatically generated by generateParts.js - Do not modify by hand - Use "npm run generate:parts" to update */
export const parts = {
  "klevu-accordion": {
    local: ["accordion-base", "accordion-header", "accordion-content", "accordion-icon"],
    exportedcomponents: {},
  },
  "klevu-badge": {
    local: ["badge-content", "badge-base"],
    exportedcomponents: {},
  },
  "klevu-banner": {
    local: ["banner-image"],
    exportedcomponents: {},
  },
  "klevu-button": {
    local: ["button-base"],
    exportedcomponents: {},
  },
  "klevu-chat-bubble": {
    local: [
      "chat-bubble-base",
      "chat-bubble-positive-feedback",
      "chat-bubble-negative-feedback",
      "chat-bubble-feedback-reasons",
    ],
    exportedcomponents: { "klevu-button": ["button-base"] },
  },
  "klevu-chat-layout": {
    local: [],
    exportedcomponents: {
      "klevu-popup": ["popup-base", "popup-content"],
      "klevu-button": ["button-base"],
      "klevu-textfield": ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
    },
  },
  "klevu-chat-messages": {
    local: [],
    exportedcomponents: {
      "klevu-chat-bubble": [
        "chat-bubble-base",
        "chat-bubble-positive-feedback",
        "chat-bubble-negative-feedback",
        "chat-bubble-feedback-reasons",
      ],
      "klevu-button": ["button-base"],
      "klevu-slides": ["slides-base", "slides-heading", "slides-previous-button", "slides-next-button"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-rating": ["rating-base", "rating-star"],
    },
  },
  "klevu-checkbox": {
    local: ["checkbox-base", "checkbox-box", "checkbox-content"],
    exportedcomponents: {},
  },
  "klevu-chip": {
    local: ["chip-base", "chip-icon", "chip-content"],
    exportedcomponents: {},
  },
  "klevu-cms-list": {
    local: ["cms-list-caption"],
    exportedcomponents: { "klevu-list": ["list-base", "list-icon", "list-image", "list-content", "list-button"] },
  },
  "klevu-drawer": {
    local: ["drawer-base", "drawer-origin", "drawer-content"],
    exportedcomponents: {},
  },
  "klevu-dropdown": {
    local: ["dropdown-base", "dropdown-select"],
    exportedcomponents: {},
  },
  "klevu-facet": {
    local: ["facet-heading", "facet-radio", "facet-more-button", "facet-option-count"],
    exportedcomponents: {
      "klevu-accordion": ["accordion-base", "accordion-header", "accordion-content", "accordion-icon"],
      "klevu-rating": ["rating-base", "rating-star"],
      "klevu-checkbox": ["checkbox-base", "checkbox-box", "checkbox-content"],
      "klevu-button": ["button-base"],
    },
  },
  "klevu-facet-list": {
    local: [],
    exportedcomponents: {
      "klevu-facet": ["facet-heading", "facet-radio", "facet-more-button", "facet-option-count"],
      "klevu-button": ["button-base"],
      "klevu-accordion": ["accordion-base", "accordion-header", "accordion-content", "accordion-icon"],
      "klevu-rating": ["rating-base", "rating-star"],
      "klevu-checkbox": ["checkbox-base", "checkbox-box", "checkbox-content"],
    },
  },
  "klevu-latest-searches": {
    local: ["latest-searches-caption"],
    exportedcomponents: { "klevu-list": ["list-base", "list-icon", "list-image", "list-content", "list-button"] },
  },
  "klevu-layout-results": {
    local: [],
    exportedcomponents: {
      "klevu-button": ["button-base"],
      "klevu-drawer": ["drawer-base", "drawer-origin", "drawer-content"],
    },
  },
  "klevu-list": {
    local: ["list-base", "list-icon", "list-image", "list-content", "list-button"],
    exportedcomponents: {},
  },
  "klevu-loading-indicator": {
    local: ["loading-indicator-base"],
    exportedcomponents: {},
  },
  "klevu-merchandising": {
    local: ["merchandising-sidebar", "merchandising-header", "merchandising-content", "merchandising-footer"],
    exportedcomponents: {
      "klevu-banner": ["banner-image"],
      "klevu-product-grid": ["product-grid-base"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-loading-indicator": ["loading-indicator-base"],
      "klevu-pagination": ["pagination-base", "pagination-navigation-previous", "pagination-navigation-next"],
      "klevu-button": ["button-base"],
      "klevu-drawer": ["drawer-base", "drawer-origin", "drawer-content"],
      "klevu-facet": ["facet-heading", "facet-radio", "facet-more-button", "facet-option-count"],
      "klevu-accordion": ["accordion-base", "accordion-header", "accordion-content", "accordion-icon"],
      "klevu-rating": ["rating-base", "rating-star"],
      "klevu-checkbox": ["checkbox-base", "checkbox-box", "checkbox-content"],
      "klevu-dropdown": ["dropdown-base", "dropdown-select"],
    },
  },
  "klevu-modal": {
    local: ["modal-base", "modal-header", "modal-dialog", "modal-body"],
    exportedcomponents: {},
  },
  "klevu-moi": {
    local: [],
    exportedcomponents: {
      "klevu-button": ["button-base"],
      "klevu-loading-indicator": ["loading-indicator-base"],
      "klevu-modal": ["modal-base", "modal-header", "modal-dialog", "modal-body"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-popup": ["popup-base", "popup-content"],
      "klevu-textfield": ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
      "klevu-chat-bubble": [
        "chat-bubble-base",
        "chat-bubble-positive-feedback",
        "chat-bubble-negative-feedback",
        "chat-bubble-feedback-reasons",
      ],
      "klevu-slides": ["slides-base", "slides-heading", "slides-previous-button", "slides-next-button"],
      "klevu-rating": ["rating-base", "rating-star"],
    },
  },
  "klevu-pagination": {
    local: ["pagination-base", "pagination-navigation-previous", "pagination-navigation-next"],
    exportedcomponents: {},
  },
  "klevu-popular-searches": {
    local: ["popular-searches-base", "popular-searches-caption", "popular-searches-list-item"],
    exportedcomponents: { "klevu-list": ["list-base", "list-icon", "list-image", "list-content", "list-button"] },
  },
  "klevu-popup": {
    local: ["popup-base", "popup-content"],
    exportedcomponents: {},
  },
  "klevu-product": {
    local: [
      "product-image",
      "product-base",
      "product-swatch",
      "product-brandname",
      "product-name",
      "product-description",
      "product-price",
      "product-vatcaption",
      "product-ooscaption",
      "product-variants-count",
      "product-addtocart",
    ],
    exportedcomponents: { "klevu-button": ["button-base"], "klevu-rating": ["rating-base", "rating-star"] },
  },
  "klevu-product-grid": {
    local: ["product-grid-base"],
    exportedcomponents: {},
  },
  "klevu-product-query": {
    local: ["product-query-open-button"],
    exportedcomponents: {
      "klevu-button": ["button-base"],
      "klevu-product-query-popup": [
        "product-query-popup-header",
        "product-query-popup-footer",
        "product-query-popup-feedback",
        "product-query-popup-question-container",
        "product-query-popup-question",
        "product-query-popup-sendmessage",
      ],
      "klevu-popup": ["popup-base", "popup-content"],
      "klevu-loading-indicator": ["loading-indicator-base"],
      "klevu-textfield": ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
      "klevu-chat-bubble": [
        "chat-bubble-base",
        "chat-bubble-positive-feedback",
        "chat-bubble-negative-feedback",
        "chat-bubble-feedback-reasons",
      ],
      "klevu-slides": ["slides-base", "slides-heading", "slides-previous-button", "slides-next-button"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-rating": ["rating-base", "rating-star"],
    },
  },
  "klevu-product-query-popup": {
    local: [
      "product-query-popup-header",
      "product-query-popup-footer",
      "product-query-popup-feedback",
      "product-query-popup-question-container",
      "product-query-popup-question",
      "product-query-popup-sendmessage",
    ],
    exportedcomponents: {
      "klevu-popup": ["popup-base", "popup-content"],
      "klevu-loading-indicator": ["loading-indicator-base"],
      "klevu-textfield": ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
      "klevu-button": ["button-base"],
      "klevu-chat-bubble": [
        "chat-bubble-base",
        "chat-bubble-positive-feedback",
        "chat-bubble-negative-feedback",
        "chat-bubble-feedback-reasons",
      ],
      "klevu-slides": ["slides-base", "slides-heading", "slides-previous-button", "slides-next-button"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-rating": ["rating-base", "rating-star"],
    },
  },
  "klevu-quicksearch": {
    local: ["quicksearch-content", "quicksearch-sidepanel", "quicksearch-main-area"],
    exportedcomponents: {
      "klevu-popup": ["popup-base", "popup-content"],
      "klevu-suggestions-list": ["suggestions-list-caption"],
      "klevu-cms-list": ["cms-list-caption"],
      "klevu-banner": ["banner-image"],
      "klevu-product-grid": ["product-grid-base"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-pagination": ["pagination-base", "pagination-navigation-previous", "pagination-navigation-next"],
      "klevu-popular-searches": ["popular-searches-base", "popular-searches-caption", "popular-searches-list-item"],
      "klevu-latest-searches": ["latest-searches-caption"],
      "klevu-tab": ["tab-base", "tab-caption"],
      "klevu-textfield": ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
      "klevu-loading-indicator": ["loading-indicator-base"],
      "klevu-button": ["button-base"],
      "klevu-list": ["list-base", "list-icon", "list-image", "list-content", "list-button"],
      "klevu-dropdown": ["dropdown-base", "dropdown-select"],
      "klevu-rating": ["rating-base", "rating-star"],
    },
  },
  "klevu-rating": {
    local: ["rating-base", "rating-star"],
    exportedcomponents: {},
  },
  "klevu-recommendations": {
    local: [],
    exportedcomponents: {
      "klevu-banner": ["banner-image"],
      "klevu-slides": ["slides-base", "slides-heading", "slides-previous-button", "slides-next-button"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-button": ["button-base"],
      "klevu-rating": ["rating-base", "rating-star"],
    },
  },
  "klevu-search-field": {
    local: [],
    exportedcomponents: {
      "klevu-textfield": ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
      "klevu-loading-indicator": ["loading-indicator-base"],
      "klevu-button": ["button-base"],
    },
  },
  "klevu-search-landing-page": {
    local: [
      "search-landing-page-header",
      "search-landing-page-content",
      "search-landing-page-sidebar",
      "search-landing-page-footer",
    ],
    exportedcomponents: {
      "klevu-quicksearch": ["quicksearch-content", "quicksearch-sidepanel", "quicksearch-main-area"],
      "klevu-banner": ["banner-image"],
      "klevu-product-grid": ["product-grid-base"],
      "klevu-product": [
        "product-image",
        "product-base",
        "product-swatch",
        "product-brandname",
        "product-name",
        "product-description",
        "product-price",
        "product-vatcaption",
        "product-ooscaption",
        "product-variants-count",
        "product-addtocart",
      ],
      "klevu-popular-searches": ["popular-searches-base", "popular-searches-caption", "popular-searches-list-item"],
      "klevu-loading-indicator": ["loading-indicator-base"],
      "klevu-pagination": ["pagination-base", "pagination-navigation-previous", "pagination-navigation-next"],
      "klevu-button": ["button-base"],
      "klevu-drawer": ["drawer-base", "drawer-origin", "drawer-content"],
      "klevu-facet": ["facet-heading", "facet-radio", "facet-more-button", "facet-option-count"],
      "klevu-accordion": ["accordion-base", "accordion-header", "accordion-content", "accordion-icon"],
      "klevu-rating": ["rating-base", "rating-star"],
      "klevu-checkbox": ["checkbox-base", "checkbox-box", "checkbox-content"],
      "klevu-popup": ["popup-base", "popup-content"],
      "klevu-suggestions-list": ["suggestions-list-caption"],
      "klevu-cms-list": ["cms-list-caption"],
      "klevu-latest-searches": ["latest-searches-caption"],
      "klevu-tab": ["tab-base", "tab-caption"],
      "klevu-textfield": ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
      "klevu-list": ["list-base", "list-icon", "list-image", "list-content", "list-button"],
      "klevu-dropdown": ["dropdown-base", "dropdown-select"],
    },
  },
  "klevu-slides": {
    local: ["slides-base", "slides-heading", "slides-previous-button", "slides-next-button"],
    exportedcomponents: { "klevu-button": ["button-base"] },
  },
  "klevu-sort": {
    local: [],
    exportedcomponents: { "klevu-dropdown": ["dropdown-base", "dropdown-select"] },
  },
  "klevu-suggestions-list": {
    local: ["suggestions-list-caption"],
    exportedcomponents: { "klevu-list": ["list-base", "list-icon", "list-image", "list-content", "list-button"] },
  },
  "klevu-tab": {
    local: ["tab-base", "tab-caption"],
    exportedcomponents: {},
  },
  "klevu-textfield": {
    local: ["textfield-base", "textfield-icon", "textfield-input", "textfield-clearbutton"],
    exportedcomponents: {},
  },
}
